import { useEffect, useState, useCallback } from 'react';
import axios from '../utils/axiosInstance';

/**
 * Fetches /api/transly/leaderboard/ — aggregated bug-hunt scores per
 * reporter_name. Phase 22.
 */
export default function useLeaderboard() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchRows = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const res = await axios.get('/api/transly/leaderboard/');
      setRows(res.data?.leaderboard || []);
    } catch (err) {
      setError(err.response?.data?.error || err.message || 'Failed to load leaderboard');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { fetchRows(); }, [fetchRows]);

  return { rows, loading, error, refresh: fetchRows };
}
